/* ===========================================================
   Univers Aquaponie — Système de favoris (wishlist)
   100% côté client (localStorage). Aucune dépendance.
   - Stocke une liste de "handles" produits dans localStorage.
   - Décore tous les boutons [data-ua-fav] (fiche produit + cartes).
   - Rend la page "Mes favoris" (#ua-fav-page) en récupérant
     chaque produit via l'API AJAX Shopify /products/{handle}.js
   Évolutif : on pourra plus tard synchroniser read()/write()
   avec le compte client sans rien changer au reste.
   =========================================================== */
(function () {
  'use strict';

  var KEY = 'ua_favorites';

  var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var STR = {
    fr: {
      add: 'Ajouter aux favoris',
      remove: 'Retirer des favoris',
      added: 'Ajouté à vos favoris ❤',
      removed: 'Retiré de vos favoris',
      empty_title: 'Votre liste de favoris est vide',
      empty_text: 'Parcourez la boutique et cliquez sur le cœur pour enregistrer vos produits préférés.',
      empty_cta: 'Voir les produits',
      loading: 'Chargement de vos favoris…'
    },
    en: {
      add: 'Add to favourites',
      remove: 'Remove from favourites',
      added: 'Added to your favourites ❤',
      removed: 'Removed from your favourites',
      empty_title: 'Your favourites list is empty',
      empty_text: 'Browse the shop and tap the heart to save your favourite products.',
      empty_cta: 'Shop products',
      loading: 'Loading your favourites…'
    }
  };
  var T = STR[lang] || STR.fr;

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var moneyLocale = lang === 'en' ? 'en-GB' : 'fr-FR';
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Icône cœur (identique au snippet icon-wishlist) pour les cartes générées en JS
  var HEART_SVG =
    '<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M5.00552 6.31802C3.24816 8.07538 3.24816 10.9246 5.00552 12.682L12.6876 20.364L20.3695 12.682C22.1268 10.9246 22.1268 8.07538 20.3695 6.31802C18.6121 4.56066 15.7629 4.56066 14.0055 6.31802L12.6876 7.63609L11.3695 6.31802C9.61212 4.56066 6.76288 4.56066 5.00552 6.31802Z" ' +
    'stroke="#020617" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>';

  /* ---------- Stockage ---------- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var arr = read();
    var i = arr.indexOf(handle);
    var added;
    if (i === -1) { arr.push(handle); added = true; }
    else { arr.splice(i, 1); added = false; }
    write(arr);
    syncButtons();
    updateCount();
    return added;
  }

  /* ---------- Boutons cœur ---------- */
  function decorate(btn) {
    var handle = btn.getAttribute('data-ua-fav-handle');
    var on = has(handle);
    btn.classList.toggle('is-fav', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? T.remove : T.add);
    btn.setAttribute('title', on ? T.remove : T.add);
  }
  function syncButtons(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-ua-fav]');
    for (var i = 0; i < nodes.length; i++) decorate(nodes[i]);
  }

  function updateCount() {
    var n = read().length;
    var counters = document.querySelectorAll('[data-ua-fav-count]');
    for (var i = 0; i < counters.length; i++) counters[i].textContent = n;
    var links = document.querySelectorAll('.ua-fav-header-link');
    for (var j = 0; j < links.length; j++) links[j].classList.toggle('has-items', n > 0);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('ua-fav-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ua-fav-toast';
      el.className = 'ua-fav-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
  }

  /* ---------- Clic (délégation globale) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ua-fav]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-ua-fav-handle');
    if (!handle) return;
    var added = toggle(handle);
    btn.classList.add('is-animating');
    setTimeout(function () { btn.classList.remove('is-animating'); }, 220);
    toast(added ? T.added : T.removed);
    if (!added) {
      var card = btn.closest('[data-ua-fav-card]');
      if (card && card.parentNode) { card.parentNode.removeChild(card); maybeEmpty(); }
    }
  });

  /* ---------- Page "Mes favoris" ---------- */
  function money(cents) {
    try {
      return (cents / 100).toLocaleString(moneyLocale, { style: 'currency', currency: currency });
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function imgUrl(u, w) {
    if (!u) return '';
    var url = u.indexOf('//') === 0 ? 'https:' + u : u;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 520);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function renderEmpty(page) {
    page.innerHTML =
      '<div class="ua-fav-empty">' +
      '<p class="ua-fav-empty-title">' + T.empty_title + '</p>' +
      '<p style="margin-bottom:1.25rem;">' + T.empty_text + '</p>' +
      '<a href="' + rootUrl + 'collections/all">' + T.empty_cta + '</a>' +
      '</div>';
  }
  function maybeEmpty() {
    var page = document.getElementById('ua-fav-page');
    if (!page) return;
    var grid = page.querySelector('.ua-fav-grid');
    if (grid && grid.children.length === 0) renderEmpty(page);
    updateCount();
  }

  function cardHtml(p) {
    var price = money(p.price);
    // Prix barre coherent (16/10/2026) : celui de la variante au prix le plus bas, comme snippets/price.liquid,
    // jamais le compare_at_price minimal du produit, qui peut venir d'une autre variante.
    var low = null;
    (p.variants || []).forEach(function (v) {
      if (v.price !== p.price) return;
      if (!low || (!low.available && v.available)) low = v;
    });
    if (low && low.compare_at_price && low.compare_at_price > low.price) {
      price += ' <s>' + money(low.compare_at_price) + '</s>';
    }
    var img = p.featured_image
      ? '<img loading="lazy" src="' + imgUrl(p.featured_image, 520) + '" alt="' + esc(p.title) + '">'
      : '<span></span>';
    return '' +
      '<a class="ua-fav-thumb" href="' + p.url + '">' + img + '</a>' +
      '<button type="button" class="ua-fav-btn ua-fav-card-btn is-fav" data-ua-fav data-ua-fav-handle="' + esc(p.handle) + '" data-ua-fav-id="' + p.id + '" aria-pressed="true" title="' + T.remove + '" aria-label="' + T.remove + '">' + HEART_SVG + '</button>' +
      '<a class="ua-fav-title" href="' + p.url + '">' + esc(p.title) + '</a>' +
      '<span class="ua-fav-price">' + price + '</span>';
  }

  function renderPage() {
    var page = document.getElementById('ua-fav-page');
    if (!page) return;
    var handles = read();
    if (!handles.length) { renderEmpty(page); updateCount(); return; }

    page.innerHTML = '<div class="ua-fav-loading">' + T.loading + '</div>';

    Promise.all(handles.map(function (h) {
      return fetch(rootUrl + 'products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var grid = document.createElement('div');
      grid.className = 'ua-fav-grid';
      var alive = [];
      for (var i = 0; i < list.length; i++) {
        var p = list[i];
        if (!p) continue;
        alive.push(handles[i]);
        var card = document.createElement('div');
        card.className = 'ua-fav-card';
        card.setAttribute('data-ua-fav-card', '');
        card.innerHTML = cardHtml(p);
        grid.appendChild(card);
      }
      page.innerHTML = '';
      if (grid.children.length === 0) { renderEmpty(page); }
      else { page.appendChild(grid); }
      if (alive.length !== handles.length) write(alive);
      updateCount();
    });
  }

  /* ---------- Init ---------- */
  function init() {
    syncButtons();
    updateCount();
    renderPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.MutationObserver) {
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (!pending) {
            pending = true;
            (window.requestAnimationFrame || window.setTimeout)(function () {
              pending = false;
              syncButtons();
            });
          }
          break;
        }
      }
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', function () { syncButtons(); updateCount(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncButtons(); updateCount(); } });

  window.UAFavorites = { get: read, has: has, toggle: toggle, count: function () { return read().length; } };
})();
